import { render, staticRenderFns } from "./SelectProductType.vue?vue&type=template&id=2c1e8290&"
import script from "./SelectProductType.vue?vue&type=script&lang=ts&"
export * from "./SelectProductType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1e8290')) {
      api.createRecord('2c1e8290', component.options)
    } else {
      api.reload('2c1e8290', component.options)
    }
    module.hot.accept("./SelectProductType.vue?vue&type=template&id=2c1e8290&", function () {
      api.rerender('2c1e8290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectProductType.vue"
export default component.exports